import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'none',
        background: '#fff',
        position: 'absolute',
        zIndex: 9999,
        width: '100%',
        height: 'inherit',
        '@media (max-width: 767px)': {
            display: 'block'
        }
    },
    enableView: {
        display: 'none'
    },
    logo: {
        backgroundImage: `url("${theme.loginLogo}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        width: '100%',
        height: 200,
        marginBottom: 15,
        marginTop: '10%',
        '@media (max-height: 700px)': {
            marginTop: 0,
            marginBottom: 0
        }
    },
    lgText: {
        fontSize: 32,
        textAlign: 'center',
        margin: '15%',
        '@media (max-width: 420px)': {
            fontSize: 26
        },
        '@media (max-height: 700px)': {
            fontSize: 26,
            marginTop: '2%',
            marginBottom: '5%'
        }
    },
    mdText: {
        fontSize: 24,
        textAlign: 'center',
        margin: '15% 15% 10% 15%',
        '@media (max-width: 420px)': {
            fontSize: 20
        },
        '@media (max-height: 700px)': {
            fontSize: 20,
            marginTop: '5%',
            marginBottom: '5%'
        }
    },
    anchorAppleBadge: {
        display: 'inline-block',
        overflow: 'hidden',
        width: '190px',
        height: '55px',
        marginTop: 13,
        '@media (max-width: 420px)': {
            width: 140,
            height: 41,
            marginTop: 10
        }
    },
    imgAppleBadge: {
        width: '190px',
        height: '55px',
        '@media (max-width: 420px)': {
            width: 140,
            height: 41
        }
    },
    imgGoogleBadge: {
        width: '200px',
        height: '80px',
        '@media (max-width: 420px)': {
            width: 150,
            height: 60
        }
    },
    appBadges: {
        display: 'flex',
        justifyContent: 'center'
    }
}))

const MobileAppScreen = ({ isEnableMobileView }) => {
    const classes = useStyles()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const { locale } = useSelector(state => state.main)

    useEffect(() => {
        if (windowWidth <= 767) {
            document.body.style.overflowX = 'hidden'
        } else {
            document.body.style.overflowX = 'auto'
        }
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleWindowResize)
        return () => {
            window.removeEventListener('resize', handleWindowResize)
        }
    }, [windowWidth])
    return (
        <div
            className={classNames(classes.wrapper, {
                [classes.enableView]: isEnableMobileView
            })}
        >
            <div className={classes.logo}></div>
            <p className={classes.lgText}>{locale.mobileAppScreen.title}</p>
            <p className={classes.mdText}>{locale.mobileAppScreen.subtitle}</p>
            <div className={classes.appBadges}>
                {/* Apple badge */}
                <a
                    href="https://apps.apple.com/us/app/traplinked/id1486351296?itsct=apps_box_badge&amp;itscg=30200"
                    className={classes.anchorAppleBadge}
                >
                    <img
                        className={classes.imgAppleBadge}
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1573776000?h=f838efb28c1edc08f1361f76d02a5d5a"
                        alt="Download on the App Store"
                    />
                </a>
                {/* Google badge */}
                <a href="https://play.google.com/store/apps/details?id=com.traplinked.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                    <img
                        className={classes.imgGoogleBadge}
                        alt="Get it on Google Play"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    />
                </a>
            </div>
        </div>
    )
}

export default withRouter(MobileAppScreen)
